import './pagination.scss';

/**
 * version     1.0
 * class       Pagination
 * classdesc   Component that manages a dynamic Bootstrap Italia pagination
 */
export class Pagination {}
